// extracted by mini-css-extract-plugin
module.exports = {"colorlist":"Colors_colorlist__3tUWW","box_color":"Colors_box_color__10erD","modal_s":"Colors_modal_s__2TCKu"};